import { API_PATH } from "../utils/config";
import { LOGIN_TIMEOUT_MS } from "./loginTimeout";

/**
 * Issue the sign-in request.
 *
 * Extracted from `useLogin` so the one thing that matters about it — that the
 * request is BOUNDED — can be asserted without mounting a react-query provider.
 * A hung login is the silent failure documented in ./loginTimeout.js.
 *
 * @param {{post: Function}} api the axios instance
 * @param {object} data the login payload
 * @returns {Promise} the axios promise
 */
export function postLogin(api, data) {
  return api.post(API_PATH.LOGIN, data, { timeout: LOGIN_TIMEOUT_MS });
}
